import React from "react";
import { Button, Input, Table } from "reactstrap";

// Reja de captura contra un documento origen (OC para embarcar, embarque para
// recibir, pedido para surtir). Recibe bloques (uno por documento) y dentro de
// cada uno un articulo por reja: renglon por color, columna por talla; cada
// celda muestra lo pendiente y un campo para capturar cuanto se mueve.
//
// bloques = [{
//   key, titulo, subtitulo?,
//   articulos: [{ idArticulo, nombre, colores: [{ _id, nombre }], tallas: [{ _id, nombre }],
//                 celdas: { "idColor|idTalla": { pendiente, cantidad } } }],
// }]
// onCambia(bloqueKey, idArticulo, idColor, idTalla, valor)
// onLlenar(bloqueKey, idArticulo | null, idColor?)   -> pone cantidad = pendiente
// onLimpiar(bloqueKey, idArticulo | null, idColor?)  -> pone cantidad = 0
// (sin articulo: todo el documento; con articulo: ese modelo; con color: esa fila)
// onQuitar(bloqueKey)
const num = (n) => new Intl.NumberFormat("en-US").format(Number(n) || 0);
const llave = (c, t) => `${c}|${t}`;

export function RejaPendientes({ bloques, onCambia, onLlenar, onLimpiar, onQuitar, etiquetaPendiente = "Pend." }) {
  if (!bloques || !bloques.length) {
    return <p style={{ color: "#9ca3af", margin: "8px 0" }}>Agrega un documento arriba para capturar sus renglones.</p>;
  }
  return (
    <>
      {bloques.map((b) => {
        const totalBloque = b.articulos.reduce((s, a) => s + Object.values(a.celdas).reduce((x, c) => x + (Number(c.cantidad) || 0), 0), 0);
        const pendBloque = b.articulos.reduce((s, a) => s + Object.values(a.celdas).reduce((x, c) => x + (Number(c.pendiente) || 0), 0), 0);
        return (
          <div key={b.key} style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 10, marginBottom: 12, background: "#fff" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 6 }}>
              <b>{b.titulo}</b>
              {b.subtitulo ? <span style={{ color: "#64748b", fontSize: 12 }}>{b.subtitulo}</span> : null}
              <span style={{ marginLeft: "auto", fontSize: 12, color: "#64748b" }}>
                {etiquetaPendiente} {num(pendBloque)} · capturado <b>{num(totalBloque)}</b>
              </span>
              <Button size="sm" color="info" onClick={() => onLlenar(b.key, null)} title="Capturar todo lo pendiente de este documento">Todo</Button>
              <Button size="sm" color="light" onClick={() => onLimpiar(b.key, null)}>Limpiar</Button>
              <Button size="sm" color="danger" onClick={() => onQuitar(b.key)} title="Quitar este documento"><i className="fas fa-times" /></Button>
            </div>
            {b.articulos.map((a) => {
              const totalArt = Object.values(a.celdas).reduce((x, c) => x + (Number(c.cantidad) || 0), 0);
              return (
                <div key={a.idArticulo} style={{ marginBottom: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13 }}>
                    <b>{a.nombre}</b>
                    {/* botones visibles: con color "link" el tema los pintaba grises y parecian deshabilitados */}
                    <Button size="sm" color="info" outline style={{ padding: "1px 8px", fontSize: 11 }}
                      title="Capturar todo lo pendiente de este modelo" onClick={() => onLlenar(b.key, a.idArticulo)}>Todo</Button>
                    <Button size="sm" color="secondary" outline style={{ padding: "1px 8px", fontSize: 11 }}
                      title="Poner este modelo en cero" onClick={() => onLimpiar(b.key, a.idArticulo)}>Limpiar</Button>
                    <span style={{ marginLeft: "auto", color: "#64748b", fontSize: 12 }}>{num(totalArt)} pzas</span>
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <Table size="sm" bordered style={{ marginBottom: 0, width: "auto", minWidth: 320 }}>
                      <thead>
                        <tr>
                          <th style={{ minWidth: 120 }}></th>
                          {a.tallas.map((t) => <th key={t._id} className="text-center" style={{ minWidth: 96 }}>{t.nombre}</th>)}
                          <th className="text-right">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {a.colores.map((c) => {
                          const totalFila = a.tallas.reduce((s, t) => s + (Number(a.celdas[llave(c._id, t._id)]?.cantidad) || 0), 0);
                          return (
                            <tr key={c._id}>
                              <td style={{ fontWeight: 600, fontSize: 12 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 6, justifyContent: "space-between" }}>
                                  <span>{c.nombre}</span>
                                  <Button size="sm" color="info" outline style={{ padding: "0 6px", fontSize: 10 }}
                                    title="Capturar todo lo pendiente de este color" onClick={() => onLlenar(b.key, a.idArticulo, c._id)}>todo</Button>
                                </div>
                              </td>
                              {a.tallas.map((t) => {
                                const celda = a.celdas[llave(c._id, t._id)];
                                if (!celda) return <td key={t._id} style={{ background: "#f8fafc" }}></td>;
                                const tope = celda.inv !== undefined ? Math.min(Number(celda.pendiente), Number(celda.inv)) : Number(celda.pendiente);
                                const pasa = Number(celda.cantidad) > tope;
                                return (
                                  <td key={t._id} style={{ padding: 3 }}>
                                    <div style={{ fontSize: 10, color: "#94a3b8", textAlign: "right" }}>
                                      {etiquetaPendiente} {num(celda.pendiente)}
                                      {celda.inv !== undefined ? <span style={{ color: Number(celda.inv) < Number(celda.pendiente) ? "#dc2626" : "#94a3b8" }}> · inv {num(celda.inv)}</span> : null}
                                    </div>
                                    <Input bsSize="sm" type="number" min="0" step="any" value={celda.cantidad ?? ""}
                                      style={pasa ? { borderColor: "#dc2626", background: "#fef2f2" } : undefined}
                                      title={pasa ? "Excede lo pendiente o la existencia" : ""}
                                      onChange={(e) => onCambia(b.key, a.idArticulo, c._id, t._id, e.target.value)} />
                                  </td>
                                );
                              })}
                              <td className="text-right" style={{ fontWeight: 700 }}>{num(totalFila)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}

// Utilidades para armar bloques desde renglones de origen.
// lineas: [{ _id, articulo: {_id, codigo, nombre}, color: {_id, codigo, name}|null, talla: {_id, name}|null, pendiente, ...extra }]
export function armaBloque(key, titulo, subtitulo, lineas) {
  const porArt = {};
  lineas.forEach((l) => {
    const idA = String(l.articulo?._id || "");
    if (!idA) return;
    if (!porArt[idA]) {
      porArt[idA] = {
        idArticulo: idA,
        nombre: `${l.articulo.codigo || ""} ${l.articulo.nombre || ""}`.trim(),
        colores: [], tallas: [], celdas: {},
      };
    }
    const a = porArt[idA];
    const idC = String(l.color?._id || "sin"), idT = String(l.talla?._id || "sin");
    if (!a.colores.some((c) => c._id === idC)) {
      a.colores.push({ _id: idC, nombre: l.color ? (l.color.name) : "Sin color" });
    }
    if (!a.tallas.some((t) => t._id === idT)) a.tallas.push({ _id: idT, nombre: l.talla ? l.talla.name : "Sin talla" });
    const k = llave(idC, idT);
    // Si hay dos renglones de la misma variante se suman en la misma celda; se guarda la lista de renglones
    if (!a.celdas[k]) a.celdas[k] = { pendiente: 0, cantidad: 0, lineas: [] };
    a.celdas[k].pendiente += Number(l.pendiente) || 0;
    // la existencia es de la variante, no del renglon: dos renglones de la misma
    // variante traen el mismo inventario, asi que no se suma
    if (l.inv !== undefined) a.celdas[k].inv = Math.max(a.celdas[k].inv || 0, Number(l.inv) || 0);
    a.celdas[k].lineas.push(l);
  });
  return { key, titulo, subtitulo, articulos: Object.values(porArt) };
}

// Aplica un cambio de celda sobre la lista de bloques (inmutable)
export function cambiaCeldaBloques(bloques, bloqueKey, idArticulo, idColor, idTalla, valor) {
  return bloques.map((b) => (b.key !== bloqueKey ? b : {
    ...b,
    articulos: b.articulos.map((a) => (a.idArticulo !== idArticulo ? a : {
      ...a,
      celdas: { ...a.celdas, [llave(idColor, idTalla)]: { ...a.celdas[llave(idColor, idTalla)], cantidad: valor === "" ? "" : Number(valor) } },
    })),
  }));
}

// idColor (opcional): solo la fila de ese color dentro del modelo
export function llenaBloques(bloques, bloqueKey, idArticulo, todo, idColor) {
  return bloques.map((b) => (b.key !== bloqueKey ? b : {
    ...b,
    articulos: b.articulos.map((a) => ((idArticulo && a.idArticulo !== idArticulo) ? a : {
      ...a,
      celdas: Object.fromEntries(Object.entries(a.celdas).map(([k, c]) => [k,
        (idColor && !k.startsWith(`${idColor}|`)) ? c
          : { ...c, cantidad: todo ? (c.inv !== undefined ? Math.min(c.pendiente, c.inv) : c.pendiente) : 0 }])),
    })),
  }));
}

// Reparte la cantidad de cada celda entre sus renglones de origen (por si una
// variante venia en dos renglones): regresa [{ linea, cantidad }]
export function lineasCapturadas(bloques) {
  const out = [];
  bloques.forEach((b) => {
    b.articulos.forEach((a) => {
      Object.values(a.celdas).forEach((c) => {
        let resta = Number(c.cantidad) || 0;
        if (resta <= 0) return;
        c.lineas.forEach((l, i) => {
          if (resta <= 0) return;
          const esUltima = i === c.lineas.length - 1;
          const toma = esUltima ? resta : Math.min(resta, Number(l.pendiente) || 0);
          if (toma > 0) out.push({ linea: l, cantidad: toma, bloque: b });
          resta -= toma;
        });
      });
    });
  });
  return out;
}

export default RejaPendientes;
